import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-fastvaluedeal-title-img.js';
const html = `
<div class="container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">Heading</h2>
    <p style="text-align: center">Description Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
  </div>
  <div
    data-attribute="wrap-images"
    data-use-mobile-image="true"
    data-max-width="900"
    data-align="center"
    class="wrap-images"
    style="--max-width: 900px"
  >
    <div class="image-desktop-wrap" data-attribute="image-desktop-wrap">
      <img
        data-attribute="image-desktop"
        class="image-desktop"
        src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e14eb7d40e8438f4da2e.png?w=1000"
        alt=""
      />
    </div>
    <div class="image-mobile-wrap" data-attribute="image-mobile-wrap">
      <img
        data-attribute="image-mobile"
        class="image-mobile"
        src="https://cdn.skyfastimg.com/images/2026/06/04/image-6a20e13f03fa9ecebe5ffd27.jpg?w=1000"
        alt=""
      />
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#ebebf3',
});
